import React from "react";

import { badgeNames } from "./badgeNames";

export type BadgeName = (typeof badgeNames)[number];

export interface BadgeProps {
  /** Which badge to render */
  name: BadgeName;
  /** Whether to show the complete or incomplete variant */
  complete?: boolean;
  /** Width and height in px (badges are square) */
  size?: number;
  className?: string;
}

// Eager-import all badge SVGs so Vite can resolve them at build time
const completeBadges: Record<BadgeName, string> = {
  assessment: new URL("../../../assets/badges/complete/assessment.svg", import.meta.url).href,
  breakfix: new URL("../../../assets/badges/complete/breakfix.svg", import.meta.url).href,
  codingChallenge: new URL("../../../assets/badges/complete/codingChallenge.svg", import.meta.url)
    .href,
  ctfChallenge: new URL("../../../assets/badges/complete/ctfChallenge.svg", import.meta.url).href,
  exercise: new URL("../../../assets/badges/complete/exercise.svg", import.meta.url).href,
  hackingChallenge: new URL("../../../assets/badges/complete/hackingChallenge.svg", import.meta.url)
    .href,
  path: new URL("../../../assets/badges/complete/path.svg", import.meta.url).href,
  quiz: new URL("../../../assets/badges/complete/quiz.svg", import.meta.url).href,
  todo: new URL("../../../assets/badges/complete/todo.svg", import.meta.url).href,
  video: new URL("../../../assets/badges/complete/video.svg", import.meta.url).href,
};

const incompleteBadges: Record<BadgeName, string> = {
  assessment: new URL("../../../assets/badges/incomplete/assessment.svg", import.meta.url).href,
  breakfix: new URL("../../../assets/badges/incomplete/breakfix.svg", import.meta.url).href,
  codingChallenge: new URL("../../../assets/badges/incomplete/codingChallenge.svg", import.meta.url)
    .href,
  ctfChallenge: new URL("../../../assets/badges/incomplete/ctfChallenge.svg", import.meta.url).href,
  exercise: new URL("../../../assets/badges/incomplete/exercise.svg", import.meta.url).href,
  hackingChallenge: new URL(
    "../../../assets/badges/incomplete/hackingChallenge.svg",
    import.meta.url
  ).href,
  path: new URL("../../../assets/badges/incomplete/path.svg", import.meta.url).href,
  quiz: new URL("../../../assets/badges/incomplete/quiz.svg", import.meta.url).href,
  todo: new URL("../../../assets/badges/incomplete/todo.svg", import.meta.url).href,
  video: new URL("../../../assets/badges/incomplete/video.svg", import.meta.url).href,
};

export const Badge: React.FC<BadgeProps> = ({ name, complete = false, size = 90, className }) => {
  const src = complete ? completeBadges[name] : incompleteBadges[name];

  return <img src={src} width={size} height={size} alt={`${name} badge`} className={className} />;
};
